import React, {useState, useContext} from "react";
import {get} from "lodash";
import {SelectBox} from "../../../Components/Pickers/SelectBox/SelectBox";
import './FileTypeFilter.scss';
import {I18nReactContext} from "../../../contexts/I18nContext";

export const FileTypeFilter = ({filterModel, setFilterModel, disabledObj}) => {
    const {i18n} = useContext(I18nReactContext);
    const [selectedType, setSelectedType] = useState(get(filterModel, 'filterValues.type', ''));

    // Options for file type filter
    const fileTypeOptions = [
        { value: '', text: i18n.translate("superAdmin.assets.filters.all") },
        { value: 'IMAGE', text: i18n.translate("superAdmin.assets.filters.image") },
        { value: 'VIDEO', text: i18n.translate("superAdmin.assets.filters.video") }
    ];

    const onSelectTypeChange = (e) => {
        setSelectedType(e.target.value);
        const newFilterModel = {
            ...filterModel,
            filterValues: {
                ...filterModel.filterValues,
                type: e.target.value
            }
        };
        setFilterModel(newFilterModel);
    };

    return <div className="searchFilter">
        <SelectBox 
            label={i18n.translate('dataGrid.filterLabels.fileType')} 
            disabled={get(disabledObj, 'disabled')} 
            options={fileTypeOptions} 
            value={selectedType} 
            onChange={onSelectTypeChange}
        />
        {get(disabledObj, 'disabled') ? <div className="disabledNotice">{get(disabledObj, 'disabledNote')}</div> : ''}
    </div>
};
